import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import {
  IonIcon,
  IonLabel,
  IonItem,
} from '@ionic/angular/standalone';
import {
  DarkModeService,
  ThemeMode,
} from '../../services/dark-mode.service';
import { Observable } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-dark-mode-toggle',
  templateUrl: './dark-mode-toggle.component.html',
  styleUrls: ['./dark-mode-toggle.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    IonIcon,
    IonLabel,
    IonItem,
  ],
})
export class DarkModeToggleComponent implements OnInit {
  isDarkMode$: Observable<boolean>;
  themeMode$: Observable<ThemeMode>;
  readonly themeModes: ThemeMode[] = ['system', 'light', 'dark'];
  @Input() iconOnly = false;
  constructor(private darkModeService: DarkModeService) {
    this.isDarkMode$ = this.darkModeService.darkMode$;
    this.themeMode$ = this.darkModeService.themeMode$;
  }

  ngOnInit() {}

  toggleDarkMode() {
    this.darkModeService.toggleDarkMode();
  }

  setThemeMode(mode: ThemeMode, event?: Event) {
    event?.stopPropagation();
    this.darkModeService.setThemeMode(mode);
  }

  getModeLabelKey(mode: ThemeMode): string {
    return `modesToggle.${mode}Mode`;
  }
}
